export const BOOK_TYPES = {
  US_SUMMARY: 'US_SUMMARY',
  US_FED: 'US_FED',
  US_STATE: 'US_STATE',
  TED_NON_US_GAAP: 'TED_NON_US_GAAP',
  TED_NON_US_STAT: 'TED_NON_US_STAT',
};

export const GROUP_BY_COLUMN_DATA = {
  BU: {
    groupByName: 'Business Unit',
    groupByField: 'BUSINESS_UNIT',
  },
  BZ: {
    groupByName: 'Business',
    groupByField: 'BUSINESS_DESCRIPTION',
  },
  CC: {
    groupByName: 'Company Code',
    groupByField: 'COMPANY_CODE',
  },
  CO: {
    groupByName: 'Country',
    groupByField: 'COUNTRY_CODE',
  },
  LE: {
    groupByName: 'Legal Entity',
    groupByField: 'LEGAL_ENTITY',
  },
  GR: {
    groupByName: 'Company Codes',
    groupByField: 'COMPANY_CODE',
  },
};

export const TOTAL_ROW_VALUE = 'Total';

// Cannot match country_tax_type_description for export purposes
export const TOTAL_FEDERAL_VALUE = 'US Fed Income Tax';

export const TOTAL_FEDERAL_ROW_FOR_US_SUMMARY = 'US Federal Income Tax';

export const TOTAL_US_ROW = 'Total US Income Tax';
